import isPropValid from '@emotion/is-prop-valid'
import styled from '@emotion/styled'

import { CONFIG } from '@/styles/emotion.config'

export const StyledTableWrapper = styled.div`
  max-width: ${CONFIG.maxWidths.lg};
  overflow-x: auto;
`

const POSITION = {
  left: '0 auto 0 0',
  right: '0 0 0 auto',
  center: '0 auto',
} as const

const TABLE_BORDER = `0.115rem solid rgba(var(--theme-surface-silver))`

export const StyledTable = styled('table', {
  shouldForwardProp: (propName) => isPropValid(propName),
})<{
  position: keyof typeof POSITION
  roundedCorners: boolean
  hasMoreThanThreeColumns: boolean
}>`
  border: ${TABLE_BORDER};
  border-spacing: 0;
  border-collapse: separate;
  border-radius: ${(props) => (props.roundedCorners ? CONFIG.theme.radii.default : '0px')};
  background-color: transparent;
  overflow: hidden;
  max-width: 100%;
  width: 100%;
  text-align: center;
  margin: ${(props) => POSITION[props.position]};

  th:not(:last-child),
  td:not(:last-child) {
    border-right: ${TABLE_BORDER};
  }

  > thead > tr:not(:last-child) > th,
  > tbody > tr:not(:last-child) > td {
    border-bottom: ${TABLE_BORDER};
  }

  ${CONFIG.media.md} {
    width: ${(props) => (props.hasMoreThanThreeColumns ? '100%' : 'unset')};
  }
`

export const StyledTableRow = styled('tr')`
  :not(:first-of-type):nth-of-type(even) {
    background: rgba(var(--theme-primary), 0.05);
  }
`

const StyledTableColumn = styled('div', {
  shouldForwardProp: (propName) => isPropValid(propName),
})<{ fontWeight: '400' | '700' }>`
  vertical-align: top;
  word-wrap: break-word;
  padding: 0.75rem;
  font-size: 0.75rem;
  font-weight: ${(props) => props.fontWeight};
  max-width: 8rem;
  min-width: unset;

  ${CONFIG.media.md} {
    padding: 1.25rem 0.75rem;
    font-size: 1rem;
    max-width: 14rem;
    min-width: 10rem;
  }
`

export const StyledTableHead = styled(StyledTableColumn.withComponent('th'))`
  background: rgba(var(--theme-primary));
  color: rgb(var(--theme-snow));
`

export const StyledTableData = styled(StyledTableColumn.withComponent('td'))`
  color: rgb(var(--theme-dark-high));
`
